import { Component } from '@angular/core';

@Component({
  selector: 'app-risk-disclosure',
  templateUrl: './risk-disclosure.component.html',
  styleUrl: './risk-disclosure.component.css',
})
export class RiskDisclosureComponent {
  lastUpdated: string = 'March 2026';
  effectiveDate: string = 'March 2026';
}
